import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-correct",
  "use": "icon-correct-usage",
  "viewBox": "0 0 1365 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1365 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-correct\"><defs><style type=\"text/css\"></style></defs><path d=\"M600.05481822 677.2007033l435.24205721-435.24205656 76.76482172 76.76482172-435.24205656 435.31447635-76.76482237 76.76482235L292.77827134 523.67105921l76.76482172-76.76482173 230.51172516 230.3668856z\" p-id=\"4870\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol